import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';
import { ModalSelectProjectComponent } from '../modal-select-project/modal-select-project.component';
import { ModalEditProjectComponent } from '../modal-edit-project/modal-edit-project.component';
import { DecimalPipe } from 'app/shared/decimal.pipe';

@Component({
	selector: 'modal-edit-warehouse-reserve-items',
	templateUrl: './modal-edit-warehouse-reserve-items.component.html'
})
export class ModalEditWarehouseReserveItemsComponent extends UIModalBaseComponent implements AfterViewInit {

	@ViewChild(ModalSelectProjectComponent) projectSelectModal: ModalSelectProjectComponent;
	@ViewChild(ModalEditProjectComponent) editProjectModal: ModalEditProjectComponent;

	disabled = false;
	dirty = false;

	warehouse_id = null;
	product;

	userList = [];
	selectedUserId = null;

	details = {
		reserved_for: null,
		quantity: 1,
		notes: null,
		reserve_for_project: 0,
		project_id: null,
		project: null,
		unit_name: ''
	};

	reservationId = null;
	originalReservedQty = 0;
	onSaved: () => void = null;

	constructor(
		public app: AppService,
		private api: ApiService
	) {
		super();
	}

	ngAfterViewInit(): void {
		super.ngAfterViewInit();
	}

	open(_mdata: any) {
		this.warehouse_id = _mdata?.warehouse || null;
		this.product = _mdata?.product || null;
		this.reservationId = _mdata?.reservationId || null;
		this.details.unit_name = this.product?.unit_name;
		this.onSaved = _mdata?.onSaved || null;
		this.loadUsers(() => {
			if (this.reservationId) {
				this.prefill(this.reservationId);
			}
			else this.resetDetails();
		});
		this.modal.open();
	}

	loadUsers(done?: () => void) {
		this.api.inventory.listOrgUsers(data => {
			this.userList = Array.isArray(data?.users) ? data.users : [];
			done?.();
		}, error => {
			this.app.notifications.showDanger(error.message);
			done?.();
		});
	}

	prefill(reservationId) {
		this.disabled = true;
		this.api.inventory.getReservationItem(reservationId, res => {
			const r = res?.reservation;
			if (!r) { this.disabled = false; return; }
			this.details.reserve_for_project = r.reserve_for_project ? 1 : 0;
			this.details.project_id = r.project_id ?? null;
			this.details.project = r.project_name ?? null;
			this.selectedUserId = r.reserved_for ?? null;
			this.details.reserved_for = r.reserved_for_name ?? null;
			this.details.quantity = r.quantity;
			this.originalReservedQty = +DecimalPipe.transform(r.quantity, 0, 4, false);
			this.details.notes = r.notes ?? null;

			if (res?.stock?.quantity_available != null) {
				this.product.quantity_available = res.stock.quantity_available;
			}

			this.disabled = false;
			this.setDirty(false);
		}, err => {
			this.disabled = false;
			this.app.notifications.showDanger(err?.message);
		});
	}

	onUserChange(userId) {
		const u = this.userList.find(x => x.id === userId);
		this.details.reserved_for = u ? u.name : null;
		this.setDirty(true);
	}

	setDirty(value = true) {
		this.dirty = value;
		this.modal.setDirty(value);
	}

	selectProject() {
		this.projectSelectModal.open({ mode: 'book' });
	}

	addNewProject() {
		this.editProjectModal.open({});
	}

	projectSelectModalClosed(data) {
		if (data) {
			this.details.project_id = data.id;
			this.details.project = data.description;
		}
	}

	removeProject() {
		this.details.project_id = null;
		this.details.project = '';
	}

	goToProject() {
		if (this.details.project_id) window.open(this.app.org + '/project/' + this.details.project_id);
	}

	onReserveForProjectChange(checked: boolean) {
		this.details.reserve_for_project = checked ? 1 : 0;
		this.setDirty(true);
	}

	onQuantityChange() {
		let val = +DecimalPipe.transform(this.details.quantity, 0, 4, false);
		const available = +DecimalPipe.transform(this.product?.quantity_available ?? 0, 0, 4, false) || 0;
		const maxAllowed = this.reservationId ? this.originalReservedQty + available : available;
		if (val > maxAllowed) { val = maxAllowed; }
		else if (val < 1) { val = 1; }

		this.details.quantity = val;
		this.setDirty(true);
	}


	private resetDetails() {
		this.details = {
			reserved_for: null,
			quantity: 1,
			notes: null,
			reserve_for_project: 0,
			project_id: null,
			project: null,
			unit_name: this.product?.unit_name
		};
		this.selectedUserId = null;
		this.disabled = false;
		this.setDirty(false);
	}


	save() {
		const payloadBase: any = {
			reserved_for: this.selectedUserId,
			quantity: this.details.quantity,
			reserve_for_project: this.details.reserve_for_project,
			notes: this.details.notes
		};
		if (payloadBase.reserve_for_project) payloadBase.project_id = this.details.project_id;

		this.disabled = true;

		if (this.reservationId) {
			this.api.inventory.updateReservationItem(
				{ reservation_id: this.reservationId, ...payloadBase },
				(res) => {
					this.app.notifications.showSuccess('Reservation updated.');
					this.setDirty(false);
					this.disabled = false;
					this.modal.close({ updated: true, reservation_id: this.reservationId });
					this.onSaved?.();
					this.resetDetails();
				},
				(err) => {
					this.disabled = false;
					this.app.notifications.showDanger(err?.message);
				}
			);
		} else {
			this.api.inventory.reserveInventoryItem(
				{
					warehouse_id: this.warehouse_id,
					sku_id: this.product?.sku_id,
					...payloadBase
				},
				(res) => {
					this.app.notifications.showSuccess('Items reserved successfully.');
					this.setDirty(false);
					this.disabled = false;
					this.modal.close(res);
					this.onSaved?.();
					this.resetDetails();
				},
				(err) => {
					this.disabled = false;
					this.app.notifications.showDanger(err?.message);
				}
			);
		}
	}
}

